import axios from 'axios';

const http = axios.create({
    baseURL: '/api/v1',
    timeout: 10000,
    withCredentials: false,
});

export async function checkAuth() {
    try {
        const { data } = await http.get('/personal/valid');
        return !!data;
    } catch (error) {
        const status = error.response?.status;
        if (status === 401 || status === 403) {
            logout();
        }
        
        return false;
    }
}
http.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export { http };

class ApiError extends Error {
    constructor({ status, title, message, code, details }) {
        super(message);
        this.status = status;
        this.title = title;
        this.code = code;
        this.details = details;
    }
}

function normalizeError(error) {
    if (!error.response) {
        return {
            status: 0,
            title: 'Network error',
            message: 'Connect failed',
            code: 'network_error',
            details: null,
            raw: error,
        };
    }
    
    const { status, data } = error.response;
    
    const title = data?.title || 'Request failed';
    const message = data?.detail || data?.message || 'Request failed';
    const code = data?.code || `http_${status}`;
    
    const details = data?.errors || null;
    
    return { status, title, message, code, details, raw: error };
}

http.interceptors.response.use(
    (response) => response.data,
    (error) => {
        const url = error.config?.url || '';
        error = normalizeError(error);
    
        if ((error.status === 401 || error.status === 403) && !url.startsWith('/personal/')) {
            logout();
        }
    
        return Promise.reject(new ApiError(error));
    }
);

function logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/auth';
}
